import type { Translation } from "@/i18n/locales/types";

export const auth: Translation["auth"] = {
  login: {
    title: "Punto.Firma",
    tagline: "Sign in with your organization's account.",
    google: "Sign in with Google",
  },
  selectOrganization: {
    title: "Which organization?",
    description:
      "Your account belongs to several organizations. You can switch later from the selector at the top left.",
    otherAccount: "Another account",
    goToPlatform: "Go to Platform",
  },
  noAccess: {
    title: "No access",
    reasons: {
      domain_not_allowed:
        "Your Google domain is not allowed in any Punto.Firma organization.",
      not_member:
        "Your account is not on any organization's list. Ask your admin to invite you.",
      suspended: "Your account is suspended. Talk to your admin.",
      no_organizations:
        "Your account does not belong to any organization. Ask your admin to invite you.",
      unknown: "Could not sign in. Please try again.",
    },
    otherAccount: "Sign in with another account",
  },
  connectMac: {
    title: "Connect Punto.Firma for Mac",
    description:
      "The app will use the certificates you are allowed in {{organization}} as {{email}}.",
    otherOrganization:
      "Want to connect it to another organization? Cancel and start again from the app: it will ask you which one.",
    connect: "Connect this Mac",
    connecting: "Connecting…",
    cancel: "Cancel",
    done: "You can go back to the app",
    doneDescription:
      "Punto.Firma for Mac has received the permission. You can close this window.",
    cancelled: "Connection cancelled",
    cancelledDescription:
      "The app has not been connected. You can close this window or try again from the app.",
    invalid: "This link is not valid",
    invalidDescription:
      "Open it from the Punto.Firma app for Mac (“Sign in with the organization account”).",
    expired: "This request has expired",
    otherAccount: "I am not {{email}}",
  },
  sessionExpired: "Your session has expired. Please sign in again.",
};
